<template>
  <a
    :href="homeLink"
    class="ct-logo-pp-report__link"
  >
    <IconLogo class="ct-logo-pp-report__icon" />
    <span class="ct-logo-pp-report__seperator" />
    <span
      class="ct-logo-pp-report__title"
      v-html="title"
    />
  </a>
</template>

<script setup lang="ts">
import IconLogo from "@/components/Icon/Logo.vue"

defineProps<{
	title: string
	homeLink: string
}>()
</script>

<style lang="postcss" scoped>
@reference '#importtailwindcss';

.ct-logo-pp-report {
  &__link {
    @apply flex items-center gap-3 lg:gap-8 h-9 lg:h-[2.4069rem];
  }

  &__icon {
    @apply w-[7.4318rem] h-9 lg:w-[7.95rem] lg:h-[2.4069rem];
  }

  &__seperator {
    @apply w-0.25 h-full bg-white;
  }

  &__title {
    @apply custom-font__pp-logo text-white;
  }
}
</style>
